import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.staging.seek.com',
    clientDomain: 'sg.staging.jobstreet.com',
    clientId: '2IP5hlebGzhmAKQRnZoOpN1JtgbLbYAY',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSTREET,
    contactUs: {
        en: 'https://sg.jobstreet.com/contact-us/',
    },
    siteName: siteNames.candidate.jobstreet.sg,
    zone: getZoneFromSite(siteNames.candidate.jobstreet.sg),
    product: Product.SEEK,
};
//# sourceMappingURL=sg_staging_jobstreet_com.js.map